import { Client } from "./_clientService";

export async function createPackCategory(pack: any) {
  try {
    const response = await new Client({
      path: `/pack-categories/create`,
      payload: pack,
    }).post();

    return response;
  } catch (error) {
    throw error;
  }
}

export async function getPackCategories() {
  try {
    const response = await new Client({
      path: `/pack-categories/list`,
    }).post();

    return response;
  } catch (error) {
    throw error;
  }
}

export async function deletePackCategory(packCategoryId: any) {
  try {
    const response = await new Client({
      path: `/pack-categories/delete`,
      payload: { packCategoryId },
    }).post();

    return response;
  } catch (error) {
    throw error;
  }
}

export async function updatePackCategoryStatus(packCategoryId: any) {
  try {
    const response = await new Client({
      path: `/pack-categories/update/status`,
      payload: { packCategoryId },
    }).post();

    return response;
  } catch (error) {
    throw error;
  }
}

export async function updatePackCategory(categoryDetails: any) {
  try {
    const response = await new Client({
      path: `/pack-categories/update`,
      payload: categoryDetails,
    }).post();

    return response;
  } catch (error) {
    throw error;
  }
}

export async function getPackCategoryInfo(packCategoryId: any) {
  try {
    const response = await new Client({
      path: `/pack-categories/info`,
      payload: { packCategoryId },
    }).post();

    return response;
  } catch (error) {
    throw error;
  }
}
